import { httpClient, _unwrapAxiosResponse, generateRollenname } from "./http";
import { Observable, Subject } from "rxjs";
import { sortStringsAlnum } from "./Termine";

export interface Studio {
  id: number;
  bezeichner: string;
  name: string;
  nummernkreis: number;
  betreiber?: string;
  wohnanschrift?: string;
  betrieb?: string;
  finanzamt?: string;
  steuernummer?: string;
}

export class StudioService {
  public getStudios(): Observable<Studio[]> {
    const scopeConfig = {
      requiredScope: "openid profile",
      requiredRoles: [],
    } as any;
    const listResult = new Subject<Studio[]>();
    _unwrapAxiosResponse<Studio[]>(
      httpClient.get("/studio", scopeConfig)
    ).subscribe(
      (studios) => {
        listResult.next(
          studios.sort((a, b) => sortStringsAlnum(a.name.toLowerCase(), b.name.toLowerCase()))
        );
        listResult.complete();
      },
      (error) => {
        listResult.error(error);
      }
    );
    return listResult;
  }
  public getStudio(bezeichner: string): Observable<Studio> {
    const scopeConfig = {
      requiredScope: "openid profile",
      requiredRoles: [],
      // requiredRoles: `studios/lesezugriff studio/${bezeichner}/lesezugriff`,
      // requiredRoles: `studios/lesezugriff`,
    } as any;
    return _unwrapAxiosResponse(
      httpClient.get(`/studio/${bezeichner}`, scopeConfig)
    );
  }

  public studioSpeichern(studio: Studio): Observable<Studio> {
    const scopeConfig = {
      requiredScope: "openid profile",
      requiredRoles: [generateRollenname(studio, null, "Schreibzugriff")],
    } as any;
    let axiosResponse;
    if (studio.id) {
      axiosResponse = httpClient.post(
        `/studio/${studio.bezeichner}`,
        studio,
        scopeConfig
      );
    } else {
      axiosResponse = httpClient.put(
        `/studio/${studio.bezeichner}`,
        studio,
        scopeConfig
      );
    }

    return _unwrapAxiosResponse(axiosResponse);
  }
}
